import React, { useEffect, useRef } from "react";
import "./MiniCaseStudy.scss";

const MiniCaseStudy = ({ title, description, image }) => {
  const imgRef = useRef(null);

  useEffect(() => {
    if (!imgRef.current) return;

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.style.animation = "slideUp 1s ease-out forwards";
          observer.unobserve(entry.target);
        }
      });
    });

    observer.observe(imgRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section className="mini-case-study">
      <div className="mini-case-study__content">
        <div className="mini-case-study__text">
          <h2>{title}</h2>
          <h5>{description}</h5>
        </div>
        <div className="mini-case-study__image">
          <img ref={imgRef} src={image} alt={title} loading="lazy" />
        </div>
      </div>
    </section>
  );
};

export default MiniCaseStudy;
